import { IApplicantParty } from "../applicant";
import { ILoan, ILoanSecurityMapping, ISecurity } from "../security";

type DetailsProps = {
  ApplicantParty: IApplicantParty[];
  Loan: ILoan[];
  Security: ISecurity[];
  LoanSecurityMapping: ILoanSecurityMapping[];
};

function multiLoansSecuritiesTransform(Details: DetailsProps) {
  // If Details doesn't have Loan array, return as-is
  if (!Details?.Loan || !Array.isArray(Details.Loan)) {
    return Details;
  }

  if (Details.LoanSecurityMapping) {
    return Details; // already using the new format
  }

  const securities: ISecurity[] = [];
  const loanSecurityMappings: ILoanSecurityMapping[] = [];
  const loans: ILoan[] = [];
  let securityIdCounter = 1;

  // Process each loan to extract securities and create mappings
  Details.Loan.forEach((loan) => {
    const { Security, ...rest } = loan;

    // Add the loan without security to the loans array
    loans.push(rest);

    // If loan has security, extract it and create mapping
    if (Security) {
      const securityWithId = {
        ...Security,
        SecurityId: securityIdCounter,
      };

      securities.push(securityWithId);

      // Create mapping between loan and security
      loanSecurityMappings.push({
        LoanId: loan.LoanId,
        SecurityId: securityIdCounter,
      });

      securityIdCounter++;
    }
  });

  // Create the transformed details object with new structure
  const transformedDetails = {
    Loan: loans,
    Security: securities,
    LoanSecurityMapping: loanSecurityMappings,
    ApplicantParty: Details.ApplicantParty || [],
    // Preserve any other properties that might exist
    // ...Object.keys(Details).reduce((acc: any, key: any) => {
    //   if (!["Loan", "ApplicantParty"].includes(key)) {
    //     acc[key] = Details[key];
    //   }
    //   return acc;
    // }, {}),
  };

  return transformedDetails;
}

export default multiLoansSecuritiesTransform;
